import { BsThreeDotsVertical } from "react-icons/bs";
import { color_grey_dark, color_white } from "../../constants/colors";
import { useWindowDimensions } from "../../utils";
import {
  OnestMediumExtraSmall,
  OnestMediumSmall,
  OnestSemiBoldMed,
} from "../styled/TextComponents";
import { useI18n } from "../../i18n/I18nProvider";

export const IconInfoBlock = ({ imageLink, title, description, onClick }) => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const isWideDesktop = screenWidth >= 1600;
  const isDesktop = screenWidth > 740;

  /*
  3 кнопки баланс/урок/до урока
  */

  return (
    <div
      style={{
        ...(isDesktop
          ? {
              flex: "1 1 0",
              minWidth: 234,
              maxWidth: isWideDesktop ? 360 : 360,
            }
          : {
              width: screenWidth <= 400 ? 100 : 110,
            }),
        height: isDesktop ? 76 : 100,
        backgroundColor: color_white,
        borderRadius: 20,
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        margin: "auto",
        position: "relative",
        flexDirection: "column",
      }}
    >
      {typeof onClick === "function" ? (
        <div
          style={{
            padding: 5,
            cursor: "pointer",
            position: "absolute",
            right: 10,
            top: 10,
          }}
          onClick={onClick}
        >
          <BsThreeDotsVertical style={{ fontSize: 20 }} />
        </div>
      ) : (
        <></>
      )}
      <div
        style={{
          width: isWideDesktop ? "100%" : isDesktop ? 200 : 90,
          height: isDesktop ? 65 : 120,
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          justifyContent: "flex-start",
          alignSelf: "center",
          padding: isDesktop ? 16 : 12,
          gap: 10,
        }}
      >
        <img
          style={{
            width: screenWidth > 740 ? 44 : 30, // размер иконки по макету
            height: screenWidth > 740 ? 44 : 30,
            //imageRendering: '-webkit-optimize-contrast',
            imageRendering: "crisp-edges",
            WebkitBackfaceVisibility: "hidden",
            backfaceVisibility: "hidden",
          }}
          src={imageLink}
          alt={"img"}
          loading="eager"
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4, // расстояние между кол-во уроков и словом проведенно
            justifyContent: "flex-start",
          }}
        >
          {isDesktop ? (
            <OnestSemiBoldMed style={{ fontSize: 16 }}>
              {t(title)}
            </OnestSemiBoldMed>
          ) : (
            <OnestSemiBoldMed style={{ fontSize: 14 }}>
              {t(title)}
            </OnestSemiBoldMed>
          )}
          {isDesktop ? (
            <OnestMediumSmall style={{ color: color_grey_dark }}>
              {t(description)}
            </OnestMediumSmall>
          ) : (
            <OnestMediumExtraSmall style={{ color: color_grey_dark }}>
              {t(description)}
            </OnestMediumExtraSmall>
          )}
        </div>
      </div>
    </div>
  );
};
